/* @flow */
import React from 'react'

const NavArrow = (props) => {
  const { icon, className, style, onClick } = props
  return (
    <div
      className={className}
      style={{...style}}
      onClick={onClick}>
      {icon()}
    </div>
  )
}

export default NavArrow


// WEBPACK FOOTER //
// ./src/components/NavArrow/index.js